<table class="table" *ngIf="ability">
  <tbody>
  <tr>
    <td>ID</td>
    <td>{{ability.server_ability_id}}</td>
  </tr>
  <tr>
    <td>Description</td>
    <td>{{ability.description}} </td>
  </tr>
</tbody>
</table>
<div class="alert alert-info">Required Abilities</div>
<table class="table table-striped" *ngIf="requiredAbilities">
  <tbody>
  <tr *ngFor="let myAbility of requiredAbilities">
    <td>{{myAbility.server_ability_id}}</td>
    <td>{{myAbility.description}}</td>
    <td>
      <button (click)="removeAbilityFromAbility(myAbility.server_ability_id)" class="mt-1"> Remove</button>
    </td>
  </tr>

</tbody>
</table>

<form  [formGroup]="searchAbilityForm" class="mt-5">
  <div class="row">
            <div class="col-sm-3" > Search Ability</div>
            <div class="col-sm-4" >
                <input   formControlName="searchInput" class="form-control"/>
            </div>
     </div>
</form>
<hr/>
<ul>
    <li *ngFor="let abilityItem of abilitySearchList;" style="list-style: none;">
    <button (click)="addAbilityToAbility(abilityItem.id)" class="mt-1"> Add Ability</button> {{abilityItem.text}}
</li>
</ul>
